import React from 'react';
import { CheckCircle2, PlayCircle, Circle } from 'lucide-react';

// Basic standard class-merging utility since cn might be customized per project
const cn = (...classes) => classes.filter(Boolean).join(' ');

const StatusTimeline = ({ stages = [], currentStage, completedStages = [], stageDates = {}, isVertical = false }) => {
    if (!stages || stages.length === 0) return null;

    return (
        <div className={cn("flex w-full", isVertical ? "flex-col space-y-4" : "flex-row items-center justify-between space-x-2 overflow-x-auto pb-4")}>
            {stages.map((stage, index) => {
                const isCompleted = completedStages.includes(stage);
                const isCurrent = stage === currentStage;

                const dateStr = stageDates[stage];
                const displayDate = dateStr ? new Date(dateStr).toLocaleDateString() : null;

                return (
                    <div key={stage} className={cn("relative flex", isVertical ? "flex-row" : "flex-col items-center flex-1")}>

                        {/* Connector Line */}
                        {index < stages.length - 1 && (
                            <div
                                className={cn(
                                    "absolute bg-stone-200 transition-colors",
                                    isVertical
                                        ? "left-[11px] top-6 bottom-[-24px] w-[2px]" // Vertical line
                                        : "top-3 left-[50%] right-[-50%] h-[2px]",  // Horizontal line
                                    (isCompleted || isCurrent) ? "bg-[hsl(145,60%,30%)]" : ""
                                )}
                                aria-hidden="true"
                            />
                        )}

                        {/* Status Icon */}
                        <div className={cn(
                            "relative z-10 flex items-center justify-center w-6 h-6 rounded-full bg-white",
                            isVertical ? "mr-4 mt-1 shrink-0" : "mb-2"
                        )}>
                            {isCompleted ? (
                                <CheckCircle2 className="w-5 h-5 text-[hsl(145,60%,30%)]" />
                            ) : isCurrent ? (
                                <div className="relative flex items-center justify-center">
                                    <div className="absolute w-5 h-5 rounded-full bg-blue-400 opacity-20 animate-ping"></div>
                                    <PlayCircle className="w-5 h-5 text-blue-600 relative z-10 bg-white rounded-full" />
                                </div>
                            ) : (
                                <Circle className="w-4 h-4 text-stone-300" />
                            )}
                        </div>

                        {/* Text Content */}
                        <div className={cn("flex flex-col z-10", isVertical ? "" : "items-center text-center")}>
                            <span className={cn(
                                "text-xs font-semibold uppercase tracking-wider",
                                isCompleted ? "text-[hsl(145,60%,20%)]" :
                                    isCurrent ? "text-blue-700 font-bold" :
                                        "text-stone-400 font-medium"
                            )}>
                                {stage.replace(/_/g, ' ')}
                            </span>
                            {displayDate && (
                                <span className="text-[10px] text-stone-500 mt-0.5">
                                    {displayDate}
                                </span>
                            )}
                            {isCurrent && (
                                <span className="text-[10px] text-blue-500 animate-pulse mt-0.5 font-medium">
                                    In Progress
                                </span>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default StatusTimeline;
